require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-realestate-com-au-masonry-house-article.json") })
        }
      }, "path---news-realestate-com-au-masonry-house-article");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-realestate-com-au-masonry-house-article!./.cache/json/news-realestate-com-au-masonry-house-article.json
// module id = 844
// module chunks = 231608221292675